import React from 'react';
import ScrollSpinner from 'components/scrollSpinner';
import "./AppLoader.scss";

const AppLoader: React.FC<{label?: string, noParent?: boolean, labelStyles?: any}> = ({label, noParent, labelStyles}) => {
    return (
        <div className={`app-loader-container ${noParent ? 'app-loader-container-noparent' : ''}`}>
            <ScrollSpinner label={label ? label : ''} labelStyles={labelStyles}/>
        </div>
    )
}

export default AppLoader;